export const S3FolderName = {
  KYC: 'kyc',
  PROFILE: 'profiles',
  ACCOUNT: 'accounts',
  ESCROW_AGREEMENT: 'escrow-agreement',
  CHALLANS: 'challans',
  SINGLE_TRANSFERS: 'transfers/single-transfers',
  BULK_TRANSFERS: 'transfers/multi-transfers',
  PAYEES: 'payees',
  DOCUMENT: 'document',
  DOQFY: 'doqfy',
  HELP_DESK: 'help-desk',
  DEAL: 'deal'
};